import React from 'react';
import NotificationOccurrenceFormPageContainer from './NotificationOccurrenceFormPageContainer'

export class NotificationOccurrenceFormPage extends React.Component {
    render(){
        return (
            <NotificationOccurrenceFormPageContainer {...this.props}/>
        )
    }
}